import React, { createContext, useContext } from 'react';

import { PatientDetails } from 'types/PatientCard.types';
import { ReferralPatientDetails } from 'types/PatientList.types';

interface TreatmentContextProps {
  clinicId: string;
  patientDetails?: PatientDetails | ReferralPatientDetails;
  hasShownThreeShapeIntro?: boolean;
  referralId?: string;
  isRefinementTemplatizedPrescriptionEnabled?: boolean;
  isBracesTemplatizedPrescriptionEnabled?: boolean;
}

const TreatmentContext = createContext<TreatmentContextProps | undefined>({
  clinicId: '',
  patientDetails: undefined,
  hasShownThreeShapeIntro: false,
  referralId: undefined,
  isRefinementTemplatizedPrescriptionEnabled: false,
  isBracesTemplatizedPrescriptionEnabled: false
});

export const useTreatmentContext = () => {
  const context = useContext(TreatmentContext);
  if (context === undefined) {
    throw new Error(
      'useTreatmentContext must be used within a TreatmentProvider'
    );
  }
  return context;
};

interface TreatmentProviderProps {
  clinicId: string;
  patientDetails?: PatientDetails | ReferralPatientDetails;
  children: React.ReactNode;
  referralId?: string;
  hasShownThreeShapeIntro?: boolean;
  isRefinementTemplatizedPrescriptionEnabled?: boolean;
  isBracesTemplatizedPrescriptionEnabled?: boolean;
}

export const TreatmentProvider: React.FC<TreatmentProviderProps> = ({
  clinicId,
  patientDetails,
  children,
  hasShownThreeShapeIntro,
  referralId,
  isRefinementTemplatizedPrescriptionEnabled,
  isBracesTemplatizedPrescriptionEnabled
}) => {
  return (
    <TreatmentContext.Provider
      value={{
        clinicId,
        patientDetails,
        hasShownThreeShapeIntro,
        referralId,
        isRefinementTemplatizedPrescriptionEnabled,
        isBracesTemplatizedPrescriptionEnabled
      }}
    >
      {children}
    </TreatmentContext.Provider>
  );
};
